import ImportTokenQR from '../components/ImportTokenQR';
import { VERSION_STRING } from '../version';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ethers } from 'ethers';
import { HybridBrowserProvider } from '../utils/HybridBrowserProvider';
import TradingAutomatizadoModal from '../components/TradingAutomatizadoModal';

import DepositModal from '../components/DepositModal';
import WithdrawModal from '../components/WithdrawModal';

import TradingWidget from '../components/TradingWidget';
import ReferralWidget from '../components/ReferralWidget';
import { useWeb3 } from '../contexts/Web3Context';
import { useWallet } from '../contexts/WalletContext';
import { useUser } from '../contexts/UserContext';
import { useStaking } from '../hooks/useStaking'; // NEW IMPORT
import Loader from '../components/Loader';
import { db, auth, functions } from '../firebaseConfig'; // ADD functions
import { httpsCallable } from "firebase/functions"; // NEW IMPORT
import { collection, query, where, orderBy, limit, getDocs, Timestamp } from "firebase/firestore";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { ThemeContext } from '../contexts/ThemeContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// --- URLs DE TUS FUNCIONES ---
const PRECIOS_URL = "https://southamerica-west1-xcoin-plataforma.cloudfunctions.net/obtenerPreciosConConversion";
const GRAFICO_URL = "https://southamerica-west1-xcoin-plataforma.cloudfunctions.net/obtenerDatosGrafico";

// --- FORMATEADORES ---
const formatCLP = (num) => new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  minimumFractionDigits: 0
}).format(num);

const formatCrypto = (num) => {
  if (num === 0) return '0,00';
  return new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8
  }).format(num);
};

// --- DATOS BASE PARA XCO (HARDCODED RESTORED) ---
const xcoBaseData = {
  price: 10000, // 1 XCO = $10.000 CLP (Aprox 10 USDT)
  changePercent: 5.4,
  isPositive: true,
  name: 'XCoin',
  currency: 'XCO'
};

// --- COMPONENTE WalletBalance ---
const WalletBalance = ({
  onChainBalance, usdtBalance, bnbBalance,
  onDeposit, onWithdraw, onShowQR,
  sessionExpired = false
}) => {
  const { wallet, connectWallet, disconnectWallet, addTokenToWallet, isConnected, forceRefresh, manualBindWallet } = useWeb3();
  const { balances, loadingBalances } = useWallet();
  const { userData } = useUser();

  if (loadingBalances) {
    return (
      <div className="card wallet-balance-container">
        <div className="balance-info"><h4>Cargando...</h4></div>
      </div>
    );
  }

  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  // STRICT VIEW LOGIC: Only show "Connected" UI if Database Binding exists and matches
  const isBound = userData?.walletAddress && wallet?.accounts[0]?.address?.toLowerCase() === userData.walletAddress?.toLowerCase();

  // Case 1: Wallet conectada Y vinculada correctamente
  const showConnectedUI = wallet && isBound;

  // Case 2: Usuario tiene wallet vinculada PERO no está conectada (sesión expirada/bloqueada)
  const showReconnectUI = userData?.walletAddress && !wallet;

  // Case 3: Wallet conectada PERO no hay wallet vinculada en DB (nuevo usuario)
  const showPendingUI = wallet && !userData?.walletAddress;

  // Case 4: Wallet conectada PERO con dirección diferente a la vinculada (mismatch)
  const showMismatchUI = wallet && userData?.walletAddress && !isBound;

  // Balances
  const xcoAmount = showConnectedUI ? parseFloat(onChainBalance) : (balances?.XCO || 0);
  const xcoValueCLP = xcoAmount * xcoBaseData.price;
  const usdtAmount = showConnectedUI ? parseFloat(usdtBalance) : 0;
  const bnbAmount = showConnectedUI ? parseFloat(bnbBalance) : 0;
  const clpAmount = balances?.CLP || 0;

  return (
    <div className="card wallet-balance-container">
      {/* Banner de sesión expirada */}
      {sessionExpired && showConnectedUI && (
        <div style={{
          background: 'rgba(255, 152, 0, 0.15)',
          border: '1px solid #ff9800',
          borderRadius: '8px',
          padding: '10px 15px',
          marginBottom: '15px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <span style={{ fontSize: '1.2rem', color: '#ff9800', fontWeight: 'bold' }}>!</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', color: '#ff9800', fontSize: '0.85rem' }}>Sesión de wallet expirada</div>
            <div style={{ fontSize: '0.75rem', color: '#aaa' }}>Haz clic en reconectar para actualizar tus saldos</div>
          </div>
          <button
            onClick={connectWallet}
            style={{
              background: '#ff9800',
              color: '#000',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '4px',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Reconectar
          </button>
        </div>
      )}
      {showConnectedUI ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
            <div>
              <h4 style={{ margin: 0, fontSize: '0.9rem', color: '#888' }}>Billetera Conectada</h4>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>{formatAddress(wallet?.accounts?.[0]?.address)}</span>
                <span style={{ fontSize: '0.7rem', padding: '2px 6px', borderRadius: '4px', background: 'rgba(76, 175, 80, 0.2)', color: '#4caf50' }}>BSC</span>
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <button onClick={disconnectWallet} style={{ background: 'transparent', border: '1px solid #444', color: '#888', padding: '4px 8px', borderRadius: '4px', fontSize: '0.7rem', cursor: 'pointer' }}>Desvincular</button>
            </div>
          </div>

          {/* ASSET GRID */}
          <div className="balance-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 1fr) minmax(120px, 1fr)', gap: '10px' }}>

            {/* XCOIN */}
            <div style={{ background: 'rgba(255, 255, 255, 0.05)', padding: '10px', borderRadius: '8px', borderLeft: '3px solid #7c4dff' }}>
              <div style={{ fontSize: '0.75rem', color: '#aaa' }}>XCoin (XCO)</div>
              <div style={{ fontSize: '1rem', fontWeight: 'bold' }}>{formatCrypto(xcoAmount)}</div>
              <div style={{ fontSize: '0.7rem', color: '#777' }}>≈ {formatCLP(xcoAmount * xcoBaseData.price)}</div>
            </div>

            {/* USDT */}
            <div style={{ background: 'rgba(255, 255, 255, 0.05)', padding: '10px', borderRadius: '8px', borderLeft: '3px solid #26a69a' }}>
              <div style={{ fontSize: '0.75rem', color: '#aaa' }}>Tether (USDT)</div>
              <div style={{ fontSize: '1rem', fontWeight: 'bold' }}>${formatCrypto(usdtAmount)}</div>
            </div>

            {/* BNB */}
            <div style={{ background: 'rgba(255, 255, 255, 0.05)', padding: '10px', borderRadius: '8px', borderLeft: '3px solid #f0b90b' }}>
              <div style={{ fontSize: '0.75rem', color: '#aaa' }}>BNB (Gas)</div>
              <div style={{ fontSize: '1rem', fontWeight: 'bold' }}>{parseFloat(bnbAmount).toFixed(4)} BNB</div>
            </div>

            {/* CLP */}
            <div style={{ background: 'rgba(255, 255, 255, 0.05)', padding: '10px', borderRadius: '8px', borderLeft: '3px solid #ffca28' }}>
              <div style={{ fontSize: '0.75rem', color: '#aaa' }}>Saldo CLP</div>
              <div style={{ fontSize: '1rem', fontWeight: 'bold' }}>{formatCLP(clpAmount)}</div>
            </div>

          </div>

          <div className="balance-actions" style={{ marginTop: '20px' }}>
            <div className="secondary-actions">
              <button className="action-btn" onClick={onDeposit}>Depositar</button>
              <button className="action-btn" onClick={onWithdraw}>Retirar</button>
            </div>
            {/* Added explicit class 'wallet-links' for mobile targeting */}
            <div className="wallet-links" style={{ marginTop: '10px', fontSize: '0.8rem', opacity: 0.7, display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <span onClick={() => addTokenToWallet && addTokenToWallet()} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#4caf50', display: 'flex', alignItems: 'center', gap: '5px' }}>
                Agregar a Wallet
              </span>
              <span onClick={onShowQR} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007bff', display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold' }}>
                📷 QR
              </span>
              <span onClick={() => disconnectWallet()} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#ff9800' }}>
                Desconectar Billetera
              </span>
            </div>
          </div>
        </>
      ) : showMismatchUI ? (
        // MISMATCH UI - Wallet conectada pero diferente a la vinculada
        <>
          <div style={{
            background: 'rgba(244, 67, 54, 0.1)',
            border: '1px solid #f44336',
            borderRadius: '12px',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '2rem', marginBottom: '10px', color: '#f44336', fontWeight: 'bold' }}>!</div>
            <h4 style={{ color: '#f44336', margin: '0 0 10px 0' }}>Wallet Incorrecta</h4>
            <p style={{ fontSize: '0.8rem', color: '#aaa', marginBottom: '10px' }}>
              Tu cuenta está vinculada a:
            </p>
            <p style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#4caf50', marginBottom: '10px' }}>
              {formatAddress(userData?.walletAddress)}
            </p>
            <p style={{ fontSize: '0.8rem', color: '#aaa', marginBottom: '5px' }}>
              Pero conectaste:
            </p>
            <p style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#f44336', marginBottom: '15px' }}>
              {formatAddress(wallet?.accounts?.[0]?.address)}
            </p>
            <p style={{ fontSize: '0.75rem', color: '#888', marginBottom: '15px' }}>
              Cambia a la wallet correcta en tu app o desconecta para reconectar.
            </p>
            <button
              className="cta-button"
              style={{ background: '#f44336', color: '#fff', fontWeight: 'bold' }}
              onClick={disconnectWallet}
            >
              Desconectar y Reintentar
            </button>
          </div>
        </>
      ) : showReconnectUI ? (
        // RECONNECT UI - Wallet vinculada pero sesión expirada (diseño compacto)
        <>
          <div style={{
            background: 'rgba(255, 152, 0, 0.08)',
            border: '1px solid rgba(255, 152, 0, 0.3)',
            borderRadius: '8px',
            padding: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#ff9800' }}>!</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: '#ff9800', fontWeight: 'bold', fontSize: '0.85rem', marginBottom: '3px' }}>
                Reconectar Wallet
              </div>
              <div style={{ fontSize: '0.75rem', color: '#888' }}>
                Vinculada: <span style={{ color: '#aaa' }}>{formatAddress(userData?.walletAddress)}</span>
              </div>
            </div>
            <button
              style={{
                background: '#ff9800',
                color: '#000',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
              onClick={connectWallet}
            >
              Conectar
            </button>
          </div>
          <div style={{ marginTop: '12px' }}>
            <div className="secondary-actions">
              <button className="action-btn" onClick={onDeposit}>Depositar</button>
              <button className="action-btn" onClick={onWithdraw}>Retirar</button>
            </div>
          </div>
        </>
      ) : showPendingUI ? (
        // PENDING BINDING UI
        <>
          <div className="balance-info">
            <h4 style={{ color: '#ff9800' }}>Billetera No Vinculada</h4>
            <p style={{ fontSize: '0.9rem', marginBottom: '10px' }}>
              Conectada: <b>{formatAddress(wallet?.accounts?.[0]?.address)}</b>
            </p>
            <p style={{ fontSize: '0.8rem', color: '#aaa' }}>
              Para ver tus saldos y operar, debes confirmar que esta es tu billetera.
            </p>
          </div>
          <div className="balance-actions">
            <button className="cta-button" style={{ background: '#4caf50' }} onClick={async () => {
              try { await manualBindWallet(); window.location.reload(); } catch (e) { }
            }}>
              Actualizar y Vincular
            </button>
            <button className="cta-button" style={{ background: '#d32f2f', marginTop: '10px' }} onClick={disconnectWallet}>
              Desconectar
            </button>
          </div>
        </>
      ) : (
        // DISCONNECTED UI
        <>
          <div className="balance-info">
            <h4>Saldo estimado (XCO)</h4>
            <p className="balance-amount">{formatCrypto(xcoAmount)} XCO</p>
            <p className="balance-secondary">≈ {formatCLP(xcoValueCLP)}</p>
          </div>
          <div className="balance-actions">
            {isConnected ? (
              <button className="cta-button" disabled>Sincronizando...</button>
            ) : (
              <button className="cta-button" onClick={connectWallet}>Vincular Billetera</button>
            )}

            <div className="secondary-actions">
              <button className="action-btn" onClick={onDeposit}>Depositar</button>
              <button className="action-btn" onClick={onWithdraw}>Retirar</button>
            </div>
            <div style={{ marginTop: '10px' }}>
              <span onClick={forceRefresh} style={{ cursor: 'pointer', background: '#444', color: '#fff', padding: '5px 10px', borderRadius: '5px', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '5px', border: '1px solid #666' }}>
                Actualizar Datos
              </span>
            </div>
          </div>

          <div style={{ marginTop: '10px', fontSize: '0.8rem', opacity: 0.7 }}>
            ¿Problemas conectando? <span onClick={() => disconnectWallet()} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#ff9800' }}>
              Resetear Conexión
            </span>
          </div>

        </>
      )}
    </div>
  );
};

// --- COMPONENTE STATSROW (UNIFIED BALANCE) ---
const StatsRow = ({ prices, web3Balances, walletConnected, isBound }) => {
  const { balances, loadingBalances } = useWallet();
  const { flexibleBalance, lockedDeposits } = useStaking();

  // Binance State
  const [binanceBalance, setBinanceBalance] = useState(0);

  // Fetch Binance Balance
  useEffect(() => {
    const fetchBinance = async () => {
      try {
        const fn = httpsCallable(functions, 'obtenerSaldoBinance');
        const res = await fn();
        if (res.data.success) {
          setBinanceBalance(parseFloat(res.data.balance));
        }
      } catch (e) {
        console.error("Dashboard: Error fetching Binance", e);
      }
    };
    fetchBinance();
  }, []);

  const calcularTotalCLP = () => {
    if (!balances) return "$0";

    // 1. Wallet Balances (Firestore vs Web3)
    const walletCLP = balances.CLP || 0;

    // Prioritize Web3 balances if wallet is connected
    const walletXCO = walletConnected && web3Balances ? parseFloat(web3Balances.XCO || 0) : (balances.XCO || 0);
    const walletUSDT = walletConnected && web3Balances ? parseFloat(web3Balances.USDT || 0) : (balances.USDT || 0);
    const walletBNB = walletConnected && web3Balances ? parseFloat(web3Balances.BNB || 0) : 0;

    // Custodial Assets (Always show if present)
    const walletBTC = balances.BTC || 0;
    const walletETH = balances.ETH || 0;

    // Prices (Passed from Parent)
    const pXCO = prices?.USDT ? prices.USDT * 10 : 9000;
    const pUSDT = prices?.USDT || 900;
    const pBTC = prices?.BTC || 0;
    const pETH = prices?.ETH || 0;
    const pBNB = prices?.BNB || 0;

    // Crypto Value
    const valXCO = walletXCO * pXCO;
    const valUSDT = walletUSDT * pUSDT;
    const valBTC = walletBTC * pBTC;
    const valETH = walletETH * pETH;
    const valBNB = walletBNB * pBNB;

    // 2. Binance Futures
    const valBinance = binanceBalance * pUSDT;

    // 3. Staking
    const flex = parseFloat(flexibleBalance || 0);
    const locked = lockedDeposits.reduce((acc, d) => acc + parseFloat(d.amount), 0);
    const valStaking = (flex + locked) * pXCO;

    const total = walletCLP + valXCO + valUSDT + valBTC + valETH + valBNB + valBinance + valStaking;

    return formatCLP(total);
  };

  const calcularSaldoDisponible = () => {
    // Usually means "Liquid" funds (CLP + Wallet XCO)
    // Or just CLP? The original code showed 'balances.CLP'.
    // Let's keep it as CLP + maybe Flexible Staking?
    // No, "Saldo Disponible" usually implies wallet funds ready to spend.
    // Original: balances?.CLP
    return formatCLP(balances?.CLP || 0);
  };

  if (loadingBalances) {
    return (
      <div className="stats-row">
        <div className="stat-card">
          <h4>Balance Total Estimado</h4>
          <p>Cargando...</p>
        </div>
        <div className="stat-card">
          <h4>Saldo Disponible (CLP)</h4>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-row">
      <div className="stat-card">
        <h4>Balance Total Estimado</h4>
        <p>{calcularTotalCLP()}</p>
        <div className="stat-chart-placeholder balance"></div>
      </div>
      <div className="stat-card">
        <h4>Saldo Disponible (CLP)</h4>
        <p>{calcularSaldoDisponible()}</p>
        <div className="stat-chart-placeholder deposit"></div>
      </div>
    </div>
  );
};

// --- NEW COMPONENT: PORTFOLIO DISTRIBUTION CHART ---
import { Doughnut } from 'react-chartjs-2';
import { ArcElement } from 'chart.js';

ChartJS.register(ArcElement);

const PortfolioDistributionChart = ({ prices, web3Balances, isBound }) => {
  const { balances, loadingBalances } = useWallet();
  const { flexibleBalance, lockedDeposits } = useStaking();
  const { wallet } = useWeb3();
  const { userData } = useUser();

  const [binanceBalanceUSD, setBinanceBalanceUSD] = useState(0);

  // 1. Fetch Binance Balance (Still internal as Dashboard doesn't lift this yet)
  useEffect(() => {
    const fetchBinance = async () => {
      try {
        const fn = httpsCallable(functions, 'obtenerSaldoBinance');
        const res = await fn();
        if (res.data.success) {
          setBinanceBalanceUSD(parseFloat(res.data.balance));
        }
      } catch (e) {
        console.error("Chart: Error fetching Binance", e);
      }
    };
    fetchBinance();
  }, []);

  if (loadingBalances) return <div className="card" style={{ padding: '20px' }}>Cargando Portafolio...</div>;

  // --- CALCULATE SECTIONS ---
  // Use Props for Prices
  const pUSDT = prices?.USDT || 900;
  const pBNB = prices?.BNB || 0;
  const pBTC = prices?.BTC || 0;
  const pETH = prices?.ETH || 0;
  const XCO_PRICE = pUSDT * 10;

  // 1. Efectivo CLP
  const valCLP = balances?.CLP || 0;

  // 2. Crypto (Wallet)
  // Only use Web3 Bals if properly Bound
  const walletXCO = (wallet && isBound && web3Balances) ? web3Balances.XCO : (balances?.XCO || 0);

  const valCrypto =
    (walletXCO * XCO_PRICE) +
    ((isBound && web3Balances ? web3Balances.USDT : 0) * pUSDT) +
    ((isBound && web3Balances ? web3Balances.BNB : 0) * pBNB) +
    ((balances?.BTC || 0) * pBTC) + // Custodial BTC
    ((balances?.ETH || 0) * pETH); // Custodial ETH

  // 3. Renta Variable (Binance)
  const valVariable = binanceBalanceUSD * pUSDT;

  // 4. Renta Fija (Staking)
  const flex = parseFloat(flexibleBalance || 0);
  const locked = lockedDeposits.reduce((acc, d) => acc + parseFloat(d.amount), 0);
  const valFija = (flex + locked) * XCO_PRICE;




  // CHART DATA
  const data = {
    labels: ['Efectivo CLP', 'Criptomonedas', 'Renta Variable', 'Renta Fija'],
    datasets: [
      {
        data: [valCLP, valCrypto, valVariable, valFija],
        backgroundColor: [
          '#ffca28', // CLP (Yellow/Gold)
          '#7c4dff', // Crypto (Purple XCoin)
          '#00e676', // Renta Variable (Green)
          '#29b6f6', // Renta Fija (Blue)
        ],
        borderColor: '#1a1a2e',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false // Disable default legend
      },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${ctx.label}: ${formatCLP(ctx.raw)}`
        }
      }
    }
  };

  const categories = [
    {
      color: '#ffca28',
      label: 'Efectivo CLP',
      desc: 'Tu saldo disponible en pesos.',
      value: valCLP
    },
    {
      color: '#7c4dff',
      label: 'Criptomonedas',
      desc: 'Wallet (XCO, USDT, BNB, BTC, ETH).',
      value: valCrypto
    },
    {
      color: '#00e676',
      label: 'Renta Variable',
      desc: 'Tu saldo en Binance Futures.',
      value: valVariable
    },
    {
      color: '#29b6f6',
      label: 'Renta Fija',
      desc: 'Tus fondos en Staking (2% - 3.5% Mensual).',
      value: valFija
    },
  ];

  return (
    <div className="card chart-widget-card" style={{ padding: '30px', minHeight: '400px' }}>
      <h3 style={{ marginBottom: '30px', fontSize: '1.3rem' }}>Distribución de Portafolio</h3>
      {(valCLP + valCrypto + valVariable + valFija) === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
          Sin saldo para mostrar gráfico.
        </div>
      ) : (
        <div className="portfolio-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '40px', alignItems: 'center' }}>
          {/* Chart Area */}
          <div style={{ height: '300px', position: 'relative' }}>
            <Doughnut data={data} options={options} />
          </div>

          {/* Custom Legend Area */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {categories.map((cat, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                {/* Color Dot */}
                <div style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  backgroundColor: cat.color, marginTop: '5px', flexShrink: 0
                }}></div>

                {/* Text Content */}
                <div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000' }}>
                    {cat.label}
                  </div>
                  <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '5px' }}>
                    {cat.desc}
                  </div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000' }}>
                    {formatCLP(cat.value)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// --- COMPONENTES PARA EL "INFO WIDGET" ---
const HistorialTransacciones = () => {
  const [transacciones, setTransacciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- HELPER: MAP TYPES ---
  const getReadableType = (tx) => {
    if (tx.description) return tx.description;

    // Robust normalization
    const type = (tx.tipo || '').toLowerCase();
    const coin = (tx.moneda || '').toUpperCase();

    if (type === 'compra' || type === 'buy') return `Compra ${coin}`;
    if (type === 'compra_bnb') return 'Compra BNB';
    if (type === 'venta' || type === 'sell') return `Venta ${coin}`;
    if (type === 'claim_staking' || type === 'claim') return 'Reclamo Recompensa Flexible';
    if (type === 'withdraw_staking') return 'Retiro Staking Flexible';
    if (type === 'staking_fixed_30' || type === 'fixed_30') return 'Depósito Plazo Fijo (30d)';
    if (type === 'staking_fixed_90' || type === 'fixed_10') return 'Depósito Plazo Fijo (90d)';
    if (type === 'staking_fixed_180' || type === 'fixed_180') return 'Depósito Plazo Fijo (180d)';
    if (type === 'referral_reward' || type === 'referral') return 'Recompensa Referido';
    if (type === 'deposit') return 'Depósito CLP';
    if (type === 'withdraw') return 'Retiro CLP';

    // If type is missing but moneda is present
    if (!type && coin) return `Operación ${coin}`;

    return tx.tipo || 'Movimiento';
  };

  const getCurrency = (tx) => {
    if (tx.method === 'CLP') return 'CLP';
    if (tx.method === 'USDT' || tx.method?.includes('Web3')) return 'USDT';
    // Inferred
    if (tx.montoCLP > 0) return 'CLP';
    return 'USDT';
  };

  const getAmountColor = (tx) => {
    const type = (tx.tipo || '').toLowerCase();
    const desc = (tx.description || '').toLowerCase();

    // Green for entries
    if (type.includes('compra') || type.includes('buy') || type.includes('deposit') ||
      type.includes('reward') || type.includes('claim') || desc.includes('compra') || desc.includes('reclamo')) {
      return '#28a745';
    }
    // Red for exits
    if (type.includes('venta') || type.includes('sell') || type.includes('withdraw') || desc.includes('venta')) {
      return '#dc3545';
    }
    return '#444'; // Gray/Visible default instead of #fff
  };

  useEffect(() => {
    const fetchTransacciones = async () => {
      try {
        if (!auth.currentUser) throw new Error("Usuario no autenticado.");
        const API_URL = import.meta.env.VITE_API_URL || 'https://dashboard.xcoin.cl';
        const res = await fetch(`${API_URL}/api/transacciones?userId=${auth.currentUser.uid}&limit=5`);
        const json = await res.json();
        if (json.success && json.data) {
          const docs = json.data.map(tx => ({
            ...tx,
            fecha: new Date(tx.fecha)
          }));
          setTransacciones(docs);
        }
      } catch (err) {
        console.error("Error al obtener transacciones:", err);
        setError("No se pudieron cargar los movimientos.");
      } finally { setLoading(false); }
    };
    fetchTransacciones();
  }, []);

  if (loading) return <div style={{ padding: '20px', textAlign: 'center' }}>Cargando movimientos...</div>;
  if (error) return <div style={{ padding: '20px', textAlign: 'center', color: '#dc3545' }}>{error}</div>;
  if (transacciones.length === 0) return <div style={{ padding: '20px', textAlign: 'center' }}>No tienes movimientos recientes.</div>;

  return (
    <table className="order-book-table">
      <thead>
        <tr>
          <th>Tipo</th>
          <th>Moneda</th>
          <th>Cantidad</th>
          <th>Fecha / Hora</th>
        </tr>
      </thead>
      <tbody>
        {transacciones.map(tx => (
          <tr key={tx.id}>
            <td style={{ color: getAmountColor(tx), fontSize: '0.85rem' }}>
              {getReadableType(tx)}
            </td>
            <td style={{ fontWeight: 'bold', fontSize: '0.75rem', opacity: 0.8 }}>
              {getCurrency(tx)}
            </td>
            <td style={{ fontSize: '0.9rem' }}>
              {formatCrypto(tx.cantidad)} {tx.moneda}
            </td>
            <td style={{ fontSize: '0.8rem', opacity: 0.6 }}>
              {tx.fecha.toLocaleString('es-CL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const PreciosMercado = () => {
  const [precios, setPrecios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrecios = async () => {
      setLoading(true);
      setError(null);
      try {
        const symbolsToFetch = ['BTC', 'ETH', 'USDT', 'BNB'];
        const response = await fetch(PRECIOS_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ data: { symbols: symbolsToFetch } })
        });

        let preciosApi = [];
        if (response.ok) {
          const result = await response.json();
          preciosApi = result.data || [];
        } else {
          console.warn("Backend prices failed, trying fallbacks...");
        }

        // --- FALLBACK CHECK FOR USDT ---
        // If USDT is missing, fetch from Buda Proxy
        let usdtItem = preciosApi.find(p => p.symbol === 'USDT');
        if (!usdtItem) {
          try {
            console.log("Fetching USDT from Buda Fallback...");
            const res = await fetch('/buda-api/v2/markets/usdt-clp/ticker');
            if (res.ok) {
              const data = await res.json();
              const price = parseFloat(data.ticker.last_price[0]);
              usdtItem = { symbol: 'USDT', priceInClp: price, name: 'Tether' };
              preciosApi.push(usdtItem);
            }
          } catch (e) {
            console.error("USDT Fallback failed", e);
          }
        }

        // --- FALLBACK CHECK FOR BNB (Using Binance API or rough est?) ---
        // If BNB missing, we might leave it or try another source. 
        // For now, focus on USDT which is critical for XCO.

        // Calc XCO Price dynamically from USDT
        const usdtPrice = usdtItem ? usdtItem.priceInClp : 900; // Default 900 if completely failed
        const xcoPrice = usdtPrice * 10;

        const xcoDataFormateado = {
          symbol: 'XCO',
          priceInClp: xcoPrice,
          name: 'XCoin',
          changePercent: xcoBaseData.changePercent,
        };

        // Explicitly build display list to ensure order and avoid filtering issues
        const displayList = [xcoDataFormateado];

        const btc = preciosApi.find(p => p.symbol === 'BTC');
        if (btc) displayList.push(btc);

        const eth = preciosApi.find(p => p.symbol === 'ETH');
        if (eth) displayList.push(eth);

        if (usdtItem) displayList.push(usdtItem);

        const bnb = preciosApi.find(p => p.symbol === 'BNB');
        if (bnb) displayList.push(bnb);

        setPrecios(displayList);

      } catch (err) {
        console.error("Error al obtener precios:", err);
        setError("No se pudieron cargar los precios.");
      } finally {
        setLoading(false);
      }
    };

    fetchPrecios();
  }, []);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Cargando precios...</div>;
  }
  if (error) {
    return <div style={{ padding: '20px', textAlign: 'center', color: '#dc3545' }}>{error}</div>;
  }

  return (
    <table className="order-book-table">
      <thead>
        <tr>
          <th>Activo</th>
          <th>Nombre</th>
          <th>Precio (CLP)</th>
        </tr>
      </thead>
      <tbody>
        {precios.map(crypto => (
          <tr key={crypto.symbol}>
            <td>{crypto.symbol}</td>
            <td>{crypto.name}</td>
            <td>{formatCLP(crypto.priceInClp)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const InfoWidget = () => {
  const [activeTab, setActiveTab] = useState('movimientos');

  return (
    <div className="order-book-card">
      <h4 style={{ textAlign: 'center' }}>Centro de Información</h4>
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === 'movimientos' ? 'active' : ''}`}
          onClick={() => setActiveTab('movimientos')}
        >
          Últimos Movimientos
        </button>
        <button
          className={`tab-button ${activeTab === 'precios' ? 'active' : ''}`}
          onClick={() => setActiveTab('precios')}
        >
          Precios de Mercado
        </button>
      </div>
      {activeTab === 'movimientos' ? (
        <HistorialTransacciones />
      ) : (
        <PreciosMercado />
      )}
    </div>
  );
};

// --- COMPONENTE PRINCIPAL (DashboardView) ---
const DashboardView = () => {
  const navigate = useNavigate();

  const [showQR, setShowQR] = useState(false);

  // --- 4. SMART WALLET SESSION LOGIC ---
  const { userData, loading: userLoading, bindWallet, checkWalletOwner } = useUser();
  const { balances, loadingBalances } = useWallet();
  const { wallet, disconnectWallet, web3Logs, forceRefresh, contract, usdtContract, refreshTrigger } = useWeb3();
  const [showLogs, setShowLogs] = useState(false);

  // STRICT VIEW LOGIC (Main Scope)
  const isBound = userData?.walletAddress && wallet?.accounts[0]?.address.toLowerCase() === userData.walletAddress.toLowerCase();

  // --- WEB3 STATE (LIFTED) ---
  const [onChainBalance, setOnChainBalance] = useState('0');
  const [usdtBalance, setUsdtBalance] = useState('0');
  const [bnbBalance, setBnbBalance] = useState('0');
  const [walletSessionExpired, setWalletSessionExpired] = useState(false);

  // Effect to fetch real balance from contract with POLLING (every 30s)
  useEffect(() => {
    const fetchBalance = async () => {
      const userAddress = wallet?.accounts?.[0]?.address;
      if (wallet && userAddress && wallet.provider) {
        try {
          // Verificar si la sesión de wallet sigue activa
          const provider = new HybridBrowserProvider(wallet.provider);
          let accounts = [];
          try {
            accounts = await provider.listAccounts();
          } catch (accErr) {
            console.warn("Wallet session check failed:", accErr.message);
          }

          // Si no hay cuentas, la sesión expiró
          if (accounts.length === 0) {
            console.log("Wallet session expired - no accounts returned");
            setWalletSessionExpired(true);
            setOnChainBalance('0');
            setUsdtBalance('0');
            setBnbBalance('0');
            // Forzar re-sync en Web3Context
            forceRefresh();
            return;
          }

          // Sesión activa - resetear flag y cargar saldos
          setWalletSessionExpired(false);

          // Fallback: usar RPC público si el provider del usuario falla
          const publicProvider = new ethers.JsonRpcProvider('https://bsc-dataseed.binance.org/');
          const XCO_ABI = ['function balanceOf(address) view returns (uint256)'];
          const USDT_ABI = ['function balanceOf(address) view returns (uint256)'];
          const XCO_ADDRESS = '0x6508AEB49733f5dAAD56621Bc2AC05193F26b53a';
          const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

          // 1. XCoin - intentar con contrato del usuario, fallback a RPC público
          try {
            if (contract) {
              const balanceWei = await contract.balanceOf(userAddress);
              setOnChainBalance(ethers.formatUnits(balanceWei, 18));
            }
          } catch (xcoErr) {
            console.warn("XCO balance via wallet failed, using public RPC:", xcoErr.message);
            const xcoContract = new ethers.Contract(XCO_ADDRESS, XCO_ABI, publicProvider);
            const balanceWei = await xcoContract.balanceOf(userAddress);
            setOnChainBalance(ethers.formatUnits(balanceWei, 18));
          }

          // 2. USDT - intentar con contrato del usuario, fallback a RPC público
          try {
            if (usdtContract) {
              const uBal = await usdtContract.balanceOf(userAddress);
              setUsdtBalance(ethers.formatUnits(uBal, 18));
            }
          } catch (usdtErr) {
            console.warn("USDT balance via wallet failed, using public RPC:", usdtErr.message);
            const usdtContractPublic = new ethers.Contract(USDT_ADDRESS, USDT_ABI, publicProvider);
            const uBal = await usdtContractPublic.balanceOf(userAddress);
            setUsdtBalance(ethers.formatUnits(uBal, 18));
          }

          // 3. BNB (Native) - intentar con provider del usuario, fallback a RPC público
          try {
            const bnbBal = await provider.getBalance(userAddress);
            setBnbBalance(ethers.formatUnits(bnbBal, 18));
          } catch (bnbErr) {
            console.warn("BNB balance via wallet failed, using public RPC:", bnbErr.message);
            const bnbBal = await publicProvider.getBalance(userAddress);
            setBnbBalance(ethers.formatUnits(bnbBal, 18));
          }

        } catch (error) {
          console.error("Error fetching on-chain balances:", error);
          // Si hay error de conexión, marcar sesión como potencialmente expirada
          if (error.message?.includes('disconnected') || error.message?.includes('user rejected')) {
            setWalletSessionExpired(true);
            forceRefresh();
          }
        }
      }
    };

    // Fetch inmediato
    fetchBalance();

    // Polling cada 30 segundos para mantener saldos actualizados y detectar sesiones expiradas
    const interval = setInterval(fetchBalance, 30000);
    return () => clearInterval(interval);
  }, [contract, usdtContract, wallet, refreshTrigger, forceRefresh]);

  // REMOVED LEGACY AUTO-BIND POLICY
  // Strict binding enforcement is now handled by Web3Context.jsx
  // This prevents the "Infinite Loop" where Admin unbinds -> Client auto-binds back immediately.

  const [searchParams, setSearchParams] = useSearchParams();
  const modalEstaAbierto = searchParams.get('modal') === 'activar-trading';

  const [showDeposit, setShowDeposit] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);

  const handleCerrarModal = () => {
    searchParams.delete('modal');
    setSearchParams(searchParams, { replace: true });
  };

  // --- PRICES FETCH FOR GLOBAL DASHBOARD STATS ---
  const [prices, setPrices] = useState({ USDT: 900, BTC: 0, ETH: 0, BNB: 0, XCO: 9000 });

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const symbolsToFetch = ['BTC', 'ETH', 'USDT', 'BNB'];
        const response = await fetch(PRECIOS_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ data: { symbols: symbolsToFetch } })
        });

        let preciosApi = [];
        if (response.ok) {
          const result = await response.json();
          preciosApi = result.data || [];
        }

        // Fallback for USDT
        let usdtItem = preciosApi.find(p => p.symbol === 'USDT');
        if (!usdtItem) {
          try {
            const res = await fetch('/buda-api/v2/markets/usdt-clp/ticker');
            if (res.ok) {
              const data = await res.json();
              usdtItem = { symbol: 'USDT', priceInClp: parseFloat(data.ticker.last_price[0]) };
              preciosApi.push(usdtItem);
            }
          } catch (e) { }
        }

        const newPrices = { ...prices };
        preciosApi.forEach(p => {
          newPrices[p.symbol] = p.priceInClp;
        });

        if (newPrices.USDT) {
          newPrices.XCO = newPrices.USDT * 10;
        }

        setPrices(newPrices);

      } catch (e) {
        console.error("Dashboard Global Price Fetch Error", e);
      }
    };
    fetchPrices();
    // Refresh every minute
    const interval = setInterval(fetchPrices, 60000);
    return () => clearInterval(interval);
  }, []);

  if (userLoading || loadingBalances) {
    return <Loader />;
  }
  if (!userData) {
    return <p>Error al cargar datos del usuario</p>
  }



  return (
    <>
      <div className="content-grid-dashboard">
        <div className="main-column">
          <WalletBalance
            onChainBalance={onChainBalance}
            usdtBalance={usdtBalance}
            bnbBalance={bnbBalance}
            onDeposit={() => setShowDeposit(true)}
            onWithdraw={() => {
              if (userData.verificationStatus !== 'verified') {
                alert(`Debes verificar tu cuenta antes de retirar.`);
                return;
              }
              setShowWithdraw(true);
            }}
            onShowQR={() => setShowQR(true)}
            sessionExpired={walletSessionExpired}
          />
          <StatsRow
            prices={prices}
            web3Balances={{
              XCO: onChainBalance,
              USDT: usdtBalance,
              BNB: bnbBalance
            }}
            walletConnected={!!wallet}
            isBound={isBound}
          />
          <PortfolioDistributionChart
            prices={prices}
            web3Balances={{
              XCO: onChainBalance,
              USDT: usdtBalance,
              BNB: bnbBalance
            }}
            isBound={isBound}
          />
        </div>
        <div className="side-column">
          {/* TradingWidget removed as per request (redundant with Market menu) */}
          <InfoWidget />
          <ReferralWidget />
        </div>
      </div>
      {/* LOG VIEWER TRIGGER (DEBUG) - FLOATING BUTTON - HIDDEN FOR PRODUCTION (set to true to enable) */}
      {false && (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
          <button
            onClick={() => setShowLogs(!showLogs)}
            style={{
              background: 'red',
              color: 'white',
              border: '2px solid white',
              fontSize: '1rem',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '30px',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0,0,0,0.5)'
            }}
          >
            {showLogs ? 'Ocultar Logs' : '🐞 VER LOGS'}
          </button>
        </div>
      )}

      {/* LOGS CONSOLE - FLOATING WINDOW - HIDDEN FOR PRODUCTION */}
      {false && showLogs && (
        <div style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          width: '90%',
          maxWidth: '600px',
          height: '300px',
          background: 'rgba(0,0,0,0.95)',
          color: '#0f0',
          fontFamily: 'monospace',
          fontSize: '0.8rem',
          padding: '15px',
          borderRadius: '10px',
          border: '1px solid #0f0',
          boxShadow: '0 4px 20px rgba(0,0,0,0.8)',
          overflowY: 'auto',
          zIndex: 9998
        }}>
          <div style={{ fontWeight: 'bold', borderBottom: '1px solid #333', marginBottom: '10px', paddingBottom: '5px' }}>
            Web3 Debug Console
            <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => setShowLogs(false)}>✖</span>
          </div>
          {web3Logs && web3Logs.length > 0 ? (
            web3Logs.map((log, idx) => (
              <div key={idx} style={{ marginBottom: '4px', borderBottom: '1px solid #111' }}>
                <span style={{ color: '#888', marginRight: '5px' }}>[{new Date(log.timestamp).toLocaleTimeString()}]</span>
                {log.message}
              </div>
            ))
          ) : (
            <div style={{ color: '#777' }}>Esperando eventos... (Interactúa con la wallet)</div>
          )}
        </div>
      )}

      <footer className="dashboard-footer">Copyright XCoin {new Date().getFullYear()}. Todos los derechos reservados. <span style={{ opacity: 0.7, fontSize: '0.9em', marginLeft: '10px' }}>{VERSION_STRING}</span></footer>

      <ImportTokenQR isOpen={showQR} onClose={() => setShowQR(false)} />
      <TradingAutomatizadoModal
        isOpen={modalEstaAbierto}
        onClose={handleCerrarModal}
        userData={userData}
      />
      <DepositModal isOpen={showDeposit} onClose={() => setShowDeposit(false)} />
      <WithdrawModal isOpen={showWithdraw} onClose={() => setShowWithdraw(false)} />
    </>
  );
};

export default DashboardView;